import { useState } from "react"

/* form */
import Input from "../../../shared/components/form/input"
import Select from 'react-select'
import selectStyles from "../../../shared/css/SelectStyle"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"

const REGIME_OPTIONS = [
    { selectName: "regimeTributario", value: "simples_nacional", label: "Simples Nacional" },
    { selectName: "regimeTributario", value: "simples_excesso", label: "Simples Nacional — excesso de sublimite" },
    { selectName: "regimeTributario", value: "regime_normal", label: "Regime Normal (Lucro Presumido/Real)" },
]

const CERTIFICATE_OPTIONS = [
    { selectName: "certificateType", value: "A1", label: "A1 (arquivo)" },
    { selectName: "certificateType", value: "A3", label: "A3 (cartão/token)" },
]

function FormFiscalConfig({ handleSubmit, configData, formId }) {

    const [config, setConfig] = useState(configData || {})

    function handleChange(e) {
        setConfig({ ...config, [e.target.name]: e.target.value })
    }

    function handleSelectChange(selectedOption) {
        setConfig({ ...config, [selectedOption.selectName]: selectedOption.value })
    }

    function submit(e) {
        e.preventDefault()
        handleSubmit(config)
    }

    const selectedRegime = REGIME_OPTIONS.find((o) => o.value === config.regimeTributario) || ""
    const selectedCertificate = CERTIFICATE_OPTIONS.find((o) => o.value === config.certificateType) || ""

    return (
        <FormLayout
            id={formId}
            onSubmit={submit}
        >
            <FormSection label="Identificação da Empresa">
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Input text="Razão Social" type="text" name="razaoSocial" handleOnChange={handleChange} value={config.razaoSocial || ''} />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input text="Nome Fantasia" type="text" name="fantasyName" handleOnChange={handleChange} value={config.fantasyName || ''} />
                    </div>
                </div>
                <div className="fl-row">
                    <div className="fl-col-narrow form-group">
                        <Input text="CNPJ" type="text" name="CNPJ" handleOnChange={handleChange} value={config.CNPJ || ''} />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input text="Inscrição Estadual" type="text" name="IE" handleOnChange={handleChange} value={config.IE || ''} />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input text="Inscrição Municipal" type="text" name="IM" placeholder="opcional" handleOnChange={handleChange} value={config.IM || ''} />
                    </div>
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Regime Tributário:</label>
                        <Select
                            options={REGIME_OPTIONS}
                            styles={selectStyles}
                            onChange={handleSelectChange}
                            value={selectedRegime}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
            </FormSection>

            <FormSection label="Endereço">
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Input text="Endereço" type="text" name="street" handleOnChange={handleChange} value={config.street || ''} />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input text="Número" type="text" name="number" handleOnChange={handleChange} value={config.number || ''} />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input text="Complemento" type="text" name="complement" handleOnChange={handleChange} value={config.complement || ''} />
                    </div>
                </div>
                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <Input text="Bairro" type="text" name="district" handleOnChange={handleChange} value={config.district || ''} />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input text="Cidade" type="text" name="city" handleOnChange={handleChange} value={config.city || ''} />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input text="UF" type="text" name="state" placeholder="Ex.: SP" handleOnChange={handleChange} value={config.state || ''} />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input text="CEP" type="text" name="cep" handleOnChange={handleChange} value={config.cep || ''} />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input text="Cód. IBGE Município" type="text" name="cityCode" placeholder="opcional" handleOnChange={handleChange} value={config.cityCode || ''} />
                    </div>
                </div>
                <div className="fl-row">
                    <div className="fl-col-narrow form-group">
                        <Input text="Telefone" type="tel" name="phone" handleOnChange={handleChange} value={config.phone || ''} />
                    </div>
                </div>
            </FormSection>

            <FormSection label="Numeração">
                <div className="fl-row">
                    <div className="fl-col-narrow form-group">
                        <Input text="Série NF-e" type="number" name="nfeSeries" placeholder="1" handleOnChange={handleChange} value={config.nfeSeries || ''} />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input text="Próximo Nº NF-e" type="number" name="nfeNextNumber" placeholder="1" handleOnChange={handleChange} value={config.nfeNextNumber || ''} />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input text="Série CT-e" type="number" name="cteSeries" placeholder="1" handleOnChange={handleChange} value={config.cteSeries || ''} />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input text="Próximo Nº CT-e" type="number" name="cteNextNumber" placeholder="1" handleOnChange={handleChange} value={config.cteNextNumber || ''} />
                    </div>
                </div>
            </FormSection>

            <FormSection label={<>Certificado Digital <span className="fl-section-optional">(apenas informativo)</span></>}>
                <p className="fl-section-hint">
                    O arquivo do certificado nunca deve ser enviado aqui — ele deve ser cadastrado direto no provedor de emissão de notas fiscais.
                    Estes campos servem só para acompanhar a validade.
                </p>
                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Tipo:</label>
                        <Select
                            options={CERTIFICATE_OPTIONS}
                            styles={selectStyles}
                            onChange={handleSelectChange}
                            value={selectedCertificate}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input text="Validade" type="date" name="certificateExpiresAt" handleOnChange={handleChange} value={config.certificateExpiresAt ? config.certificateExpiresAt.slice(0, 10) : ''} />
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormFiscalConfig
